module.exports = __webpack_public_path__ + "static/img/netflix-step3.256b8e3.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/promotion/netflix-step3.png
// module id = 144
// module chunks = 1